import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  ControlLabel,
  Input,
  SelectPicker,
  Uploader,
  DatePicker,
  Message,
  Checkbox,
} from 'rsuite'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
import EditButton from '../../components/buttons/editButton/EditButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { useForm, Controller } from 'react-hook-form'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { DATE_PICKER_FORMAT, DD_MM_YYYY_SLASH } from '../../constants/date'
import moment from 'moment'
import { isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import ViewFileseFilling from '../../pages/incomeAndExpense/eFillingListForm/ViewFileseFilling'
import { API_ROOT } from '../../config/config'
import ViewFileseFillingWidget from './ViewFileseFillingWidget'
import { getValueOptionsByLabel } from '../../utils/dataUtil'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { downloadEfillingFileByPath } from '../../redux/actions/eFilling'
import { doneLoading, startLoading } from '../../utils/loading'

export default function ListFormeFilling({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  rowData,
  isAddBankAccount,
  isPreeviewFile,
  previewSchema,
  onUploadSuccess = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [formSchema, setFormSchema] = useState(schema)
  const defaultMaxFileSize = 5
  const [submisStatusVal, setSubmisStatusVal] = useState('0')
  const [CheckStatusVal, setCheckStatusVal] = useState('0')
  const [rowDataItem, setRowDataItem] = useState()
  const [accessToken, setAccessToken] = useState()
  const [ModelTypeVal, setModelTypeVal] = useState('')
  const [MasterModelTypeVal, setMasterModelTypeVal] = useState('')
  const [ImportDataVal, setImportDataVal] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileTableData, setFileTableData] = useState([])
  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  const [taxFilePath, setTaxFilePath] = useState()
  const [billFilePath, setaBillFilePath] = useState()

  const [projectCode, setProjectCode] = useState('')
  const [taxFileList, setTaxFileList] = useState([])
  const [taxMount, setTaxMount] = useState(
    rowData?.taxMonth
      ? moment(rowData?.taxMonth, DD_MM_YYYY_SLASH).toDate()
      : moment().startOf('day').toDate()
  )

  const [isTHSequenceNo, setIsTHSequenceNo] = useState(false)

  useEffect(() => {
    const _accessToken = localStorage.getItem('access_token')
    setAccessToken(_accessToken)

    const projectCode = sessionStorage.getItem('projectCode')
    setProjectCode(projectCode || '')
  }, [])

  useEffect(() => {
    // console.log('fileTableData==>', fileTableData)
  }, [fileTableData])

  useEffect(() => {
    if (rowData && !isAddBankAccount) {
      // console.log('rowData==>', rowData)
      setValue(formSchema.projectCode.name, rowData.projectCode)
      setValue(formSchema.taxReferCode.name, rowData.taxReferCode)

      setTaxMount(moment(rowData?.taxMonth, DD_MM_YYYY_SLASH).toDate())

      if (rowData?.taxMonth instanceof Date) {
        let _taxMonth = new Date(rowData?.taxMonth)
        _taxMonth.setDate(1)

        let _submitDate = new Date(rowData?.submisDate)
        _submitDate.setDate(1)

        const taxMonthYear = _taxMonth.getFullYear() * 12 + _taxMonth.getMonth()
        const submitMonthYear = _submitDate.getFullYear() * 12 + _submitDate.getMonth()

        if (taxMonthYear >= submitMonthYear) {
          setValue(formSchema?.submisDate?.name, null)
        } else {
          setValue(
            formSchema?.submisDate?.name,
            rowData?.submisDate ? moment(rowData?.submisDate, DD_MM_YYYY_SLASH).toDate() : null //moment().startOf('day').toDate()
          )
        }
      }

      if(rowData.thSequenceNo){
        setIsTHSequenceNo(true)
      }

      setValue(
        formSchema.modelType.name,
        getValueOptionsByLabel(formSchema.modelType.options, rowData.modelType)
      )
      setValue(
        formSchema?.taxMonth?.name,
        rowData?.taxMonth
          ? moment(rowData?.taxMonth, DD_MM_YYYY_SLASH).toDate()
          : moment().startOf('day').toDate()
      )

      setValue(
        formSchema?.receiptDate?.name,
        rowData?.receiptDate
          ? moment(rowData?.receiptDate, DD_MM_YYYY_SLASH).toDate()
          : moment().startOf('day').toDate()
      )
      setValue(formSchema.submisFormType.name, rowData.submisFormType)
      setValue(formSchema.submisList.name, rowData.thSequenceNo ? rowData.thSequenceNo : rowData.submisList)
      setValue(formSchema.submisType.name, rowData.submisType)
      setValue(formSchema.submisStatus.name, rowData.submisStatus)
      setValue(formSchema.submisSubStatus.name, rowData.submisSubStatus)
      setValue(formSchema.submitName.name, rowData.submitName)
      setValue(formSchema.phoneNumber.name, rowData.submitContrctPhoneNo)
      // setValue(formSchema.attachTaxFiles.name, rowData.withholdingTaxFormPath)
      // setValue(formSchema.attachReceiptFiles.name, rowData.billFilePath)
      clearErrors()

      // console.log('withholdingTaxFormPath==>', rowData.withholdingTaxFormPath)
      // console.log('billFilePath==>', rowData.billFilePath)

      setTaxFilePath(rowData.withholdingTaxFormPath)
      setaBillFilePath(rowData.billFilePath)

      register('isDeleteTaxFile', false)
      register('taxFilePath', rowData.withholdingTaxFormPath)
      setValue('isDeleteTaxFile', false)
      setValue('taxFilePath', rowData.withholdingTaxFormPath)

      register('isDeleteBillFile', false)
      register('billFilePath', rowData.billFilePath)
      setValue('isDeleteBillFile', false)
      setValue('billFilePath', rowData.billFilePath)
      setValue('remark', rowData.remark)

      setRowDataItem(rowData)
      setCheckStatusVal(rowData.submisStatus)
      setModelTypeVal(getValueOptionsByLabel(formSchema.modelType.options, rowData.modelType))
      setMasterModelTypeVal(getValueOptionsByLabel(formSchema.modelType.options, rowData.modelType))
    } else {
      let _taxMount = new Date(taxMount)
      _taxMount.setMonth(_taxMount.getMonth() + 1)
      _taxMount.setDate(1)

      setValue(formSchema.projectCode.name, projectCode)
      setValue(formSchema.contractNo.name, '')
      setValue(
        formSchema?.submisDate?.name,
        formSchema?.submisDate?.value
          ? moment(formSchema.submisDate.value, DATE_PICKER_FORMAT).toDate()
          : _taxMount //moment().startOf('day').toDate()
      )
      setValue(formSchema.modelType.name, '')
      setValue(
        formSchema?.taxMonth?.name,
        formSchema?.taxMonth?.value
          ? moment(formSchema.taxMonth.value, DATE_PICKER_FORMAT).toDate()
          : moment().startOf('day').toDate()
      )
      setValue(formSchema.submisList.name, '')
      setValue(formSchema.submisType.name, '')
      setValue(formSchema.submisStatus.name, '')
      setValue(formSchema.submisSubStatus.name, '')
      setValue(formSchema.submitName.name, '')
      setValue(formSchema.phoneNumber.name, '')
      setValue(formSchema.attachTaxFiles.name, '')
      setValue(formSchema.attachReceiptFiles.name, '')
      setValue(formSchema.remark.name, '')
    }
  }, [rowData])

  const onDownload = async (filePath, fileName) => {
    startLoading()
    try {
      var file = await downloadEfillingFileByPath(filePath)
      //var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (filePath, fileName) => {
    startLoading()
    try {
      var file = await downloadEfillingFileByPath(filePath)
      //var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDeleteTaxFile = (filePath) => {
    setValue('isDeleteTaxFile', true)
    setValue('taxFilePath', filePath)

    setTaxFilePath(null)
  }

  const onDeleteBillFile = (filePath) => {
    setValue('isDeleteBillFile', true)
    setValue('billFilePath', filePath)

    setaBillFilePath(null)
  }

  const handleDeleteFileTable = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  const handleFileChange = (fileList) => {
    // ตรวจสอบว่า fileList ไม่ใช่ค่าว่างเปล่า
    // console.log('Preview fileList:', fileList)
    if (!isEmpty(fileList)) {
      // อัปเดตสถานะ fileTableData ด้วย fileList ใหม่
      setFileTableData(
        fileList.map((file) => ({
          uid: file.uid,
          name: file.name,
          status: file.status,
          url: file.url || URL.createObjectURL(file.originFileObj), // สร้าง URL ถ้าไม่มี
        }))
      )
    }
  }

  return (
    <>
      <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
        <ControlLabel>
          {requiredFiled(formSchema.projectCode.validators, formSchema.projectCode.label)}
        </ControlLabel>
        {!isAddBankAccount ? (
          <p>{rowData.projectCode || ''}</p>
        ) : (
          <>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />

            <Controller
              name={formSchema.projectCode.name}
              control={control}
              defaultValue={projectCode || ''}
              value={projectCode || ''}
              rules={isValidators(formSchema.projectCode.validators)}
              render={(props) => {
                return (
                  <Input
                    readOnly
                    placeholder={'ระบุ' + formSchema.projectCode.label}
                    value={projectCode}
                    onChange={(value, e) => {
                      props.onChange(value.trim())
                    }}
                    disabled={formSchema.projectCode.disabled}
                  />
                )
              }}
            />
          </>
        )}
      </Col>
      <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
        <ControlLabel>
          {requiredFiled(formSchema.submisList.validators, formSchema.submisList.label)}
        </ControlLabel>
        {!isAddBankAccount && !isTHSequenceNo ? (
          <div style={{ marginTop: 10 }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              {rowData?.submisList || ''}
              
            </Col>
            
           
            <Col lg={16} md={16} sm={24} xs={24}>
              <Checkbox checked={isTHSequenceNo} onChange={()=>setIsTHSequenceNo(!isTHSequenceNo)} style={{bottom: 7}}>
                มีเลขลำดับการยื่น
              </Checkbox>
            </Col>
          
          
          </div>
        ) : (
          <div>
          <Col lg={!isAddBankAccount ? 8 : 24} md={!isAddBankAccount ? 8 : 24} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.submisList.name]} />
            <Controller
              name={formSchema.submisList.name}
              control={control}
              //defaultValue={formSchema.submisList.value || ''}
              defaultValue={rowData?.thSequenceNo || rowData?.sequenceNo}
              rules={isValidators(formSchema.submisList.validators)}
              render={(props) => {
                return (
                  <Input
                    readOnly={!isTHSequenceNo}
                    placeholder={'ระบุ' + formSchema.submisList.label}
                    value={isAddBankAccount ? 'XXX' : props.value}
                    maxLength={getMaxLengthData(formSchema.submisList.validators).value}
                    onChange={(value, e) => {
                      if (isNaN(value)) {
                        return
                      }
                      props.onChange(value.trim())
                    }}
                    disabled={formSchema.submisList.disabled}
                  />
                )
              }}
            />
          </Col>

          {!isAddBankAccount &&
            <Col lg={16} md={16} sm={24} xs={24}>
              <Checkbox checked={isTHSequenceNo} onChange={()=>setIsTHSequenceNo(!isTHSequenceNo)}>
                มีเลขลำดับการยื่น
              </Checkbox>
            </Col>}
          </div>
        )}
        </Col>
      

      <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
        <ControlLabel>
          {requiredFiled(formSchema.taxMonth.validators, formSchema.taxMonth.label)}
        </ControlLabel>

        <ErrorMessage error={errors[formSchema.taxMonth.name]} />
        {/* {console.log(errors)} */}
        <Controller
          key={formSchema.taxMonth.name}
          name={formSchema.taxMonth.name}
          control={control}
          defaultValue={
            rowData?.taxMonth
              ? moment(rowData?.taxMonth, DD_MM_YYYY_SLASH).toDate()
              : moment().startOf('day').toDate()
          }
          rules={isValidators(formSchema.taxMonth.validators)}
          render={(props) => {
            return (
              <DatePicker
                block
                format="MM/YYYY"
                ranges={[]}
                onOk={(e) => {
                  console.log(e)
                }}
                onChange={(value) => {
                  props.onChange(value)
                  setTaxMount(value)

                  if (value instanceof Date) {
                    let _taxMonth = new Date(value)
                    _taxMonth.setDate(1)

                    let _submitDate = new Date(getValues(formSchema?.submisDate?.name))
                    _submitDate.setDate(1)

                    const taxMonthYear = _taxMonth.getFullYear() * 12 + _taxMonth.getMonth()
                    const submitMonthYear = _submitDate.getFullYear() * 12 + _submitDate.getMonth()

                    if (taxMonthYear >= submitMonthYear) {
                      setValue(formSchema?.submisDate?.name, null)
                    }
                  }
                }}
                value={props.value ? moment(props.value).toDate() : null}
              />
            )

            // <DatePickerCustom {...props} />
          }}
          // render={(props) => {
          //   return <DatePickerCustom {...props} />
          // }}
        />
      </Col>
      <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10, marginBottom: 20 }}>
        <ControlLabel>
          {requiredFiled(formSchema.modelType.validators, formSchema.modelType.label)}
        </ControlLabel>
        {!isAddBankAccount ? (
          <p>{rowData.modelType || ''} </p>
        ) : (
          <>
            <ErrorMessage error={errors[formSchema.modelType.name]} />
            <Controller
              name={formSchema.modelType.name}
              control={control}
              // defaultValue={formSchema.modelType.value}
              rules={isValidators(formSchema.modelType.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modelType.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'เลือก' + formSchema.modelType.label}
                    onChange={(value) => {
                      props.onChange(value)
                      setModelTypeVal(value)
                      // console.log('ModelTypeVal===>', value)
                    }}
                  />
                )
              }}
            />
          </>
        )}
      </Col>

      <Row style={{ marginLeft: 0, marginRight: 0 }}>
        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.submisDate.validators, formSchema.submisDate.label)}
          </ControlLabel>

          <ErrorMessage error={errors[formSchema.submisDate.name]} />
          <Controller
            key={formSchema.submisDate.name}
            name={formSchema.submisDate.name}
            control={control}
            defaultValue={
              rowData?.submisDate ? moment(rowData?.submisDate, DD_MM_YYYY_SLASH).toDate() : null //moment().startOf('day').toDate()
            }
            rules={isValidators(formSchema.submisDate.validators)}
            render={(props) => {
              return (
                <>
                  <DatePickerCustom
                    {...props}
                    //value={props.value < taxMount ? null : props.value }
                    disabledDate={(date) => {
                      let _taxMount = new Date(taxMount)
                      _taxMount.setMonth(_taxMount.getMonth() + 1)
                      _taxMount.setDate(1)
                      return _taxMount && moment(_taxMount).isAfter(date, new Date())
                    }}
                  />
                  {formSchema?.submisDate?.infoMessage && (
                    <Message
                      showIcon
                      type="info"
                      description={formSchema?.submisDate?.infoMessage}
                      closable
                    />
                  )}
                </>
              )
            }}
          />
        </Col>

        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.submisType.validators, formSchema.submisType.label)}
          </ControlLabel>

          <ErrorMessage error={errors[formSchema.submisType.name]} />
          <Controller
            name={formSchema.submisType.name}
            control={control}
            defaultValue={rowData?.submisType || '0'}
            rules={isValidators(formSchema.submisType.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={formSchema.submisType.options}
                  value={props.value}
                  style={{ width: '100%' }}
                  searchable={false}
                  placeholder={'เลือก' + formSchema.submisType.label}
                  onChange={(value) => {
                    props.onChange(value)
                    setSubmisStatusVal(value)
                    // console.log('setSubmisStatusVal===>', submisStatusVal)
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>

      {!isAddBankAccount && (
        <>
          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.submisStatus.validators, formSchema.submisStatus.label)}
            </ControlLabel>

            <ErrorMessage error={errors[formSchema.submisStatus.name]} />
            <Controller
              name={formSchema.submisStatus.name}
              control={control}
              defaultValue={formSchema.submisStatus.value}
              rules={isValidators(formSchema.submisStatus.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={rowData.statusOptions || formSchema.submisStatus.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'เลือก' + formSchema.submisStatus.label}
                    onChange={(value) => {
                      props.onChange(value)
                      setCheckStatusVal(value)
                      //console.log('value===>', value)
                    }}
                  />
                )
              }}
            />
          </Col>

          {CheckStatusVal != '0' && CheckStatusVal != '9' && (
            <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
              <ControlLabel>
                {requiredFiled(formSchema.taxReferCode.validators, formSchema.taxReferCode.label)}
              </ControlLabel>

              <ErrorMessage error={errors[formSchema.taxReferCode.name]} />

              <Controller
                name={formSchema.taxReferCode.name}
                control={control}
                defaultValue={rowData.taxReferCode || ''}
                rules={isValidators(formSchema.taxReferCode.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.taxReferCode.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.taxReferCode.disabled}
                    />
                  )
                }}
              />
            </Col>
          )}
        </>
      )}

      {CheckStatusVal == '2' && (
        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.submitName.validators, formSchema.submitName.label)}
          </ControlLabel>

          <ErrorMessage error={errors[formSchema.submitName.name]} />

          <Controller
            name={formSchema.submitName.name}
            control={control}
            defaultValue={rowData.submitName || ''}
            rules={isValidators(formSchema.submitName.validators)}
            render={(props) => {
              return (
                <Input
                  placeholder={'ระบุ' + formSchema.submitName.label}
                  value={props.value}
                  onChange={(value, e) => {
                    props.onChange(value)
                  }}
                  disabled={formSchema.submitName.disabled}
                />
              )
            }}
          />
        </Col>
      )}

      {(CheckStatusVal == '2' || CheckStatusVal == '9') && (
        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.phoneNumber.validators, formSchema.phoneNumber.label)}
          </ControlLabel>

          <ErrorMessage error={errors[formSchema.phoneNumber.name]} />

          <Controller
            name={formSchema.phoneNumber.name}
            control={control}
            defaultValue={rowData.submitContrctPhoneNo || ''}
            rules={isValidators(formSchema.phoneNumber.validators)}
            render={(props) => {
              return (
                <Input
                  placeholder={'ระบุ' + formSchema.phoneNumber.label}
                  value={props.value}
                  onChange={(value, e) => {
                    // props.onChange(value.trim())
                    // console.log('value', value)
                    if (isNaN(value)) {
                      return
                    }
                    props.onChange(value)
                  }}
                  disabled={formSchema.phoneNumber.disabled}
                />
              )
            }}
          />
        </Col>
      )}

      {CheckStatusVal == '9' && (
        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.submisSubStatus.validators, formSchema.submisSubStatus.label)}
          </ControlLabel>

          <ErrorMessage error={errors[formSchema.submisSubStatus.name]} />
          <Controller
            name={formSchema.submisSubStatus.name}
            control={control}
            defaultValue={rowData.submisSubStatus}
            rules={isValidators(formSchema.submisSubStatus.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={formSchema.submisSubStatus.options}
                  value={props.value}
                  style={{ width: '100%' }}
                  searchable={false}
                  placeholder={'เลือก' + formSchema.submisSubStatus.label}
                  onChange={(value) => {
                    props.onChange(value)
                    //setCheckStatusVal(value)
                    //console.log('value===>', value)
                  }}
                />
              )
            }}
          />
        </Col>
      )}

      {CheckStatusVal == '2' && (
        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.receiptDate.validators, formSchema.receiptDate.label)}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema.receiptDate.name]} />
          <Controller
            key={formSchema.receiptDate.name}
            name={formSchema.receiptDate.name}
            control={control}
            defaultValue={
              rowDataItem?.receiptDate
                ? moment(rowDataItem?.receiptDate, DD_MM_YYYY_SLASH).toDate()
                : moment().startOf('day').toDate()
            }
            rules={isValidators(formSchema.receiptDate.validators)}
            render={(props) => {
              return <DatePickerCustom {...props} />
            }}
          />
        </Col>
      )}

      {CheckStatusVal == '2' && (
        <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
          <ControlLabel>
            {requiredFiled(formSchema.submisFormType.validators, formSchema.submisFormType.label)}
          </ControlLabel>

          <ErrorMessage error={errors[formSchema.submisFormType.name]} />
          <Controller
            name={formSchema.submisFormType.name}
            control={control}
            defaultValue={rowData.submisFormType}
            rules={isValidators(formSchema.submisFormType.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={formSchema.submisFormType.options}
                  value={props.value}
                  style={{ width: '100%' }}
                  searchable={false}
                  placeholder={'เลือก' + formSchema.submisFormType.label}
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
      )}

      <Col lg={24} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
        <ControlLabel>
          {requiredFiled(formSchema.remark.validators, formSchema.remark.label)}
        </ControlLabel>

        <ErrorMessage error={errors[formSchema.remark.name]} />

        <Controller
          name={formSchema.remark.name}
          control={control}
          defaultValue={formSchema.remark.value || ''}
          rules={isValidators(formSchema.remark.validators)}
          render={(props) => {
            return (
              <Input
                componentClass="textarea"
                placeholder={'ระบุ' + formSchema.remark.label}
                value={props.value}
                onChange={(value, e) => {
                  props.onChange(value)
                }}
                disabled={formSchema.remark.disabled}
              />
            )
          }}
        />
      </Col>

      <Row style={{ marginTop: 25 }}>
        {/* แนบแบบภาษี */}

        {(CheckStatusVal == 1 || CheckStatusVal == 2) && (
          <>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.attachFormTaxFiles.validators,
                  formSchema.attachFormTaxFiles.label || 'แนบแบบภาษี '
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.attachFormTaxFiles.name]} />
              <Controller
                key={formSchema.attachFormTaxFiles.name}
                name={formSchema.attachFormTaxFiles.name}
                control={control}
                rules={!taxFilePath && isValidators(formSchema.attachFormTaxFiles.validators)}
                defaultValue={''}
                render={(props) => {
                  if (taxFilePath) {
                    return (
                      <Row style={{ marginTop: 25 }}>
                        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
                        <Col lg={20} md={20} sm={24} xs={24}>
                          <ButtonGroup>
                            <IconButton
                              appearance="ghost"
                              size="sm"
                              icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                              onClick={(e) =>
                                onPreview(
                                  taxFilePath,
                                  formSchema.attachFormTaxFiles.label || 'แนบแบบภาษี '
                                )
                              }
                              // disabled={!item?.path}
                            />
                            <IconButton
                              appearance="ghost"
                              size="sm"
                              icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                              onClick={(e) =>
                                onDownload(
                                  taxFilePath,
                                  formSchema.attachFormTaxFiles.label || 'แนบแบบภาษี '
                                )
                              }
                              // disabled={!item?.path}
                            />
                            <IconButton
                              appearance="ghost"
                              size="sm"
                              className="rs-btn-ghost-cancel"
                              icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                              onClick={(e) => onDeleteTaxFile(taxFilePath)}
                              // disabled={!item?.path}
                            />
                          </ButtonGroup>
                        </Col>
                      </Row>
                    )
                  } else {
                    return (
                      <Uploader
                        accept={formSchema.attachFormTaxFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                        autoUpload={false}
                        disabled={
                          formSchema.attachFormTaxFiles.disabled || formSchema.isReceiveAnnuity
                        }
                        fileListVisible={true}
                        listType="picture-text"
                        fileList={props.value || []}
                        multiple={false}
                        onChange={(fileList) => {
                          console.log(fileList)
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]

                            if (
                              file.blobFile.size >
                              (formSchema?.attachFormTaxFiles?.fileSize || defaultMaxFileSize) *
                                1024 *
                                1024
                            ) {
                              notification.open('error', {
                                title: `ขนาดไฟล์เกิน ${
                                  formSchema.attachFormTaxFiles.fileSize || defaultMaxFileSize
                                } MB`,
                                duration: 5000,
                              })
                              return
                            }

                            if (isImageOrPdf(file.blobFile.type)) {
                              let lastFile = [file]

                              // console.log('lastFile', lastFile)
                              props.onChange(lastFile)
                              setFileTypeError(false)
                            } else {
                              setFileTypeError(true)
                              notification.open('error', {
                                title:
                                  'ชนิดที่รองรับ ' + formSchema.attachFormTaxFiles.fileType ||
                                  '.jpg, .jpeg, .png, .pdf',
                                duration: 5000,
                              })
                            }
                          }
                        }}
                        draggable
                      >
                        <div>
                          <Icon size="2x" icon="upload2" />
                          <small className="uploder__text"></small>
                          {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                            formSchema.attachFormTaxFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                          } , ขนาดไฟล์ไม่เกิน ${
                            formSchema.attachFormTaxFiles.fileSize || defaultMaxFileSize
                          } MB`}
                        </div>
                      </Uploader>
                    )
                  }
                }}
              />
            </Col>
          </>
        )}

        {/* แนบใบเสร็จรับเงิน */}
        {CheckStatusVal == 2 && (
          <>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.attachReceiptFiles.validators,
                  formSchema.attachReceiptFiles.label || 'แนบใบเสร็จรับเงิน '
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.attachReceiptFiles.name]} />
              <Controller
                key={formSchema.attachReceiptFiles.name}
                name={formSchema.attachReceiptFiles.name}
                control={control}
                rules={!billFilePath && isValidators(formSchema.attachReceiptFiles.validators)}
                defaultValue={''}
                render={(props) => {
                  if (billFilePath) {
                    return (
                      <Row style={{ marginTop: 25 }}>
                        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
                        <Col lg={20} md={20} sm={24} xs={24}>
                          <ButtonGroup>
                            <IconButton
                              appearance="ghost"
                              size="sm"
                              icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                              onClick={(e) =>
                                onPreview(
                                  billFilePath,
                                  formSchema.attachReceiptFiles.label || 'แนบใบเสร็จรับเงิน '
                                )
                              }
                              // disabled={!item?.path}
                            />
                            <IconButton
                              appearance="ghost"
                              size="sm"
                              icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                              onClick={(e) =>
                                onDownload(
                                  billFilePath,
                                  formSchema.attachReceiptFiles.label || 'แนบใบเสร็จรับเงิน '
                                )
                              }
                              // disabled={!item?.path}
                            />
                            <IconButton
                              appearance="ghost"
                              size="sm"
                              className="rs-btn-ghost-cancel"
                              icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                              onClick={(e) => onDeleteBillFile(billFilePath)}
                              // disabled={!item?.path}
                            />
                          </ButtonGroup>
                        </Col>
                      </Row>
                    )
                  } else {
                    return (
                      <Uploader
                        accept={formSchema.attachReceiptFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                        autoUpload={false}
                        disabled={
                          formSchema.attachReceiptFiles.disabled || formSchema.isReceiveAnnuity
                        }
                        fileListVisible={true}
                        listType="picture-text"
                        fileList={props.value || []}
                        multiple={false}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]

                            if (
                              file.blobFile.size >
                              (formSchema?.attachReceiptFiles?.fileSize || defaultMaxFileSize) *
                                1024 *
                                1024
                            ) {
                              notification.open('error', {
                                title: `ขนาดไฟล์เกิน ${
                                  formSchema.attachReceiptFiles.fileSize || defaultMaxFileSize
                                } MB`,
                                duration: 5000,
                              })
                              return
                            }

                            if (isImageOrPdf(file.blobFile.type)) {
                              let lastFile = [file]

                              // console.log('lastFile', lastFile)
                              props.onChange(lastFile)
                              setFileTypeError(false)
                            } else {
                              setFileTypeError(true)
                              notification.open('error', {
                                title:
                                  'ชนิดที่รองรับ ' + formSchema.attachReceiptFiles.fileType ||
                                  '.jpg, .jpeg, .png, .pdf',
                                duration: 5000,
                              })
                            }
                          }
                        }}
                        draggable
                      >
                        <div>
                          <Icon size="2x" icon="upload2" />
                          <small className="uploder__text"></small>
                          {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                            formSchema.attachReceiptFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                          } , ขนาดไฟล์ไม่เกิน ${
                            formSchema.attachReceiptFiles.fileSize || defaultMaxFileSize
                          } MB`}
                        </div>
                      </Uploader>
                    )
                  }
                }}
              />
            </Col>
          </>
        )}
      </Row>

      {isAddBankAccount && ModelTypeVal && (
        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.attachTaxFiles.validators,
                formSchema.attachTaxFiles.label || 'แนบเอกสารรายชื่อผู้เสียภาษี '
              )}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {ModelTypeVal && MasterModelTypeVal && ModelTypeVal != MasterModelTypeVal && (
              <Message showIcon type="error" description="กรุณาแนบแอกสารให้ตรงกับประเภทแบบ" />
            )}
            <Uploader
              accept={formSchema.attachTaxFiles.fileType || '.xlsx'}
              headers={{ Authorization: `Bearer ${accessToken}` }}
              multiple={false}
              listType="picture-text"
              draggable
              fileList={taxFileList || []}
              fileListVisible={false}
              onChange={(fileList) => {
                //console.log('taxFileList', taxFileList)
                setTaxFileList(fileList)
                // setRowData(rowData.id, {
                //   localFileList: fileList,
                // })
              }}
              onUpload={() => {
                // setRowData(rowData.id, {
                //   isLoading: true,
                // })
              }}
              onSuccess={(response, file) => {
                // console.log('response==>', response)
                if (response?.model?.length > 0) {
                  setImportDataVal(response.model)
                  setMasterModelTypeVal(ModelTypeVal)
                  onUploadSuccess(response.model)

                  setTaxFileList([{ ...file }])

                  notification.open('success', {
                    title: 'แนบสำเร็จ',
                  })
                } else {
                  notification.open('error', {
                    title: response.errorMessage || 'ไม่พบข้อมูลในเอกสารแนบ',
                  })

                  if (taxFileList?.length > 0) {
                    setTaxFileList([])
                  }
                }
              }}
              onError={(e, file) => {
                var _fileList = taxFileList

                if (_fileList?.length > 0) {
                  _fileList.pop()

                  console.log('_fileList', _fileList)
                  setTaxFileList(_fileList)
                }

                //setTaxFileList([])
                // setRowData(rowData.id, {
                //   isLoading: false,
                //   localFileList: [],
                // })
                // onUploadError(e)
                console.log('error', e)
                notification.open('error', {
                  title: e?.response?.errorMessage || 'แนบเอกสารไม่สำเร็จ',
                })
              }}
              action={`${API_ROOT}/v1/accounting/e-filling/import`}
              name={'File'}
              data={{
                WithholdingType: ModelTypeVal || '',
              }}
            >
              <div>
                <Icon size="2x" icon="upload2" />
                <small className="uploder__text"></small>
                {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                  formSchema.attachTaxFiles.fileType || '.xlsx'
                } , ขนาดไฟล์ไม่เกิน ${formSchema.attachTaxFiles.fileSize || defaultMaxFileSize} MB`}
              </div>
            </Uploader>

            <p style={{ fontSize: '1em' }}>
              <b>{ImportDataVal.length > 0 ? taxFileList[0]?.name : ''}</b>
            </p>
          </Col>
        </Row>
      )}

      {isPreeviewFile && (ImportDataVal.length > 0 || previewSchema.length > 0) && (
        <ViewFileseFillingWidget
          dataList={isAddBankAccount ? ImportDataVal : previewSchema}
          taxType={MasterModelTypeVal}
        />
      )}
    </>
  )
}
